import { api, ApiError } from '@/lib/api';
import type { WalkReport, UpsertWalkReportInput } from './types';

/** The walk's report, or null if the walker hasn't started one yet (404). */
export async function fetch_walk_report(booking_id: string): Promise<WalkReport | null> {
  try {
    const res = await api.get<WalkReport>(`/vendor/bookings/${booking_id}/walk-report`);
    return res.data;
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return null;
    throw err;
  }
}

export async function save_walk_report(booking_id: string, input: UpsertWalkReportInput): Promise<WalkReport> {
  const res = await api.put<WalkReport>(`/vendor/bookings/${booking_id}/walk-report`, input);
  return res.data;
}

export async function publish_walk_report(booking_id: string): Promise<WalkReport> {
  const res = await api.post<WalkReport>(`/vendor/bookings/${booking_id}/walk-report/publish`);
  return res.data;
}

/** Owner read — the published walk report for a booking, or null (404 while DRAFT/none). */
export async function fetch_owner_walk_report(booking_id: string): Promise<WalkReport | null> {
  try {
    const res = await api.get<WalkReport>(`/user/bookings/${booking_id}/walk-report`);
    return res.data;
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return null;
    throw err;
  }
}
